<template>
  <div class="g-search flex-box">
    <div class="g-search-input flex-box">
      <i class="iconfont icon-sousuo"></i>
      <p>点击搜索模特、艺人的名字、经历...</p>
    </div>
    <i class="iconfont" :class="[isNew ? 'isnew ' + icon : icon]"></i>
  </div>
</template>

<script>
  import {mapState, mapActions, mapMutations} from 'vuex'
  import * as getData from '../service/getData'
  export default {
    data () {
      return {

      }
    },
    created () {
      console.log(this.$store.state.platform)
    },
    props: {
      icon: {
        type: String,
        default: 'icon-guanli'
      },
      isNew: {
        type: Boolean,
        default: false
      }

    },
    computed: {

    },

    methods: {


    },
    components: {
    }
  }
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';
  .g-search{
    position: relative;
    z-index: 99;
    @include wh(100%,.88rem);
    background-color: #191919;
    padding: .14rem .36rem;
    .g-search-input{
      flex: 1;
      height: 100%;
      border-radius: .31rem;
      background-color: #777;
      i{
        @include sc(.38rem,$fc);
        margin-left: .35rem;
        margin-right: .1rem;
      }
      p{
        @include sc(.28rem,$fc);
        line-height: .4rem;
      }
    }
    i{
      @include sc(.4rem,$fc);
      margin-left: .4rem;
    }
    .isnew{
      position: relative;
      &::after{
        content: '';
        position: absolute;
        top: 0;
        right: -.04rem;
        @include wh(.16rem,.16rem);
        background-color: #F74E45;
        border-radius: 50%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// search.vue?3369ebec